import { useState, useContext } from 'react';
import { Play } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function ReleaseModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleRelease = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.releaseAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit publié avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la publication du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error releasing audit plan:', error);
      showError('Erreur lors de la publication du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleRelease}
      title="Publier le plan d'audit"
      message="Êtes-vous sûr de vouloir publier ce plan d'audit ? Une fois publié, les auditeurs pourront commencer à travailler dessus."
      confirmText={loading ? 'Publication en cours...' : 'Publier'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<Play className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
